import { Icon as SonansIcon, AvailableIcons } from '@sonans/components'

type IconType =
    | 'check'
    | 'chevron'
    | 'close'
    | 'warning'
    | 'arrow-right'
    | 'plus'
    | 'arrow-left'
    | 'reset'
    | 'info'
    | 'chat'
    | 'open_in_new'

type Props = {
    type?: IconType
    className?: string
}

const iconMap: Record<IconType, AvailableIcons> = {
    check: 'check',
    chevron: 'keyboard_arrow_down',
    close: 'close',
    warning: 'warning',
    'arrow-right': 'arrow_forward',
    'arrow-left': 'arrow_back',
    plus: 'add',
    reset: 'undo',
    info: 'info',
    chat: 'forum',
    open_in_new: 'open_in_new',
}

export function Icon({ type = 'check', className = '' }: Props) {
    return <SonansIcon icon={iconMap[type]} className={className} />
}
